import { ResetStore, SetPlugins } from '@/constants/mutations';
import { ClearStore, FetchPlugins, GetPluginById, UpdatePlugin } from '@/constants/actions';
import { GetPlugins } from '@/constants/getters';
import { endpoints } from '@/services/amplify-api/endpoints';

const defaultState = () => {
  return {
    plugins: [],
  };
};

export const state = defaultState;

export const mutations = {
  [ResetStore]: (state) => {
    Object.assign(state, defaultState());
  },

  [SetPlugins]: (state, plugins) => {
    state.plugins = plugins;
  },
};

export const actions = {
  [ClearStore]({ commit }) {
    commit(ResetStore);
  },

  async [FetchPlugins]({ commit }) {
    try {
      const params = {
        activeOnly: true,
      }
      const { data } = await this.$amplifyApi.get(endpoints.plugin.base, { params });

      commit(SetPlugins, data?.data ?? []);
    } catch (error) {
      console.error(error);
    }
  },

  async [GetPluginById]({ commit }, id) {
    try {
      const { data } = await this.$amplifyApi.get(endpoints.plugin.byId(id));

      return data;
    } catch (error) {
      console.error(error);
    }
  },

  async [UpdatePlugin]({ commit }, data) {
    try {
      const { id, ...newData } = data;

      await this.$amplifyApi.patch(endpoints.plugin.byId(id), newData);
    } catch (error) {
      console.error(error);
    }
  },
};

export const getters = {
  [GetPlugins]: (state) => state.plugins || [],
};
